export default [
    {
        title: 'evoucher.title',
        fontIcon: 'file-invoice',
        resource: 'Evoucher',
        action: 'ver-evoucher',
        children: [
            {
                title: 'Dashboard',
                icon: 'LayoutIcon',
                resource: 'Evoucher',
                action: 'ver-evoucher-dashboard',
                children: [
                    {
                        route: 'evoucher-dashboard-vouchers',
                        title: 'evoucher.dashboard.vouchers.title',
                        fontIcon: 'chart-line',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-dashboard-vouchers',
                    },
                ],
            },
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Evoucher',
                action: 'ver-evoucher-matenimiento',
                children: [
                    {
                        route: 'evoucher-matenimiento-cargar-comprobantes',
                        title: 'evoucher.matenimiento.cargar-comprobantes.title',
                        fontIcon: 'file-import',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-matenimiento-cargar-comprobantes',
                    },
                    {
                        route: 'evoucher-matenimiento-firma',
                        title: 'evoucher.matenimiento-firma.title',
                        fontIcon: 'file-import',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-matenimiento-firma',
                    },
                ],
            },
            {
                title: 'Transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Evoucher',
                action: 'ver-evoucher-transacciones',
                children: [
                    {
                        route: 'evoucher-transacciones-facturas',
                        title: 'evoucher.transacciones.facturas.title',
                        fontIcon: 'file-lines',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-transacciones-facturas',
                    },
                    {
                        route: 'evoucher-transacciones-notas-debito',
                        title: 'evoucher.transacciones.notas-debito.title',
                        fontIcon: 'file-lines',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-transacciones-notas-debito',
                    },
                    {
                        route: 'evoucher-transacciones-notas-credito',
                        title: 'evoucher.transacciones.notas-credito.title',
                        fontIcon: 'file-lines',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-transacciones-notas-credito',
                    },
                    {
                        route: 'evoucher-transacciones-guias-remision',
                        title: 'evoucher.transacciones.guias-remision.title',
                        fontIcon: 'file-lines',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-transacciones-guias-remision',
                    },
                    {
                        route: 'evoucher-transacciones-liquidacion-compra',
                        title: 'evoucher.transacciones.liquidacion-compra.title',
                        fontIcon: 'file-lines',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-transacciones-liquidacion-compra',
                    },
                    {
                        route: 'evoucher-transacciones-comprobante-retencion',
                        title: 'evoucher.transacciones.comprobante-retencion.title',
                        fontIcon: 'file-lines',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-transacciones-comprobante-retencion',
                    },
                    {
                        route: 'evoucher-transacciones-firmar-documento',
                        title: 'evoucher.transacciones.firmar-documento.title',
                        fontIcon: 'file-signature',
                        resource: 'Evoucher',
                        action: 'ver-evoucher-transacciones-firmar-documento',
                    },
                ],
            },
        ],
    },
]
